module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row d-flex align-items-end wrapper mt-5 pb-3"
  }, [_c('div', {
    staticClass: "col-12 col-sm-3 d-none d-sm-block"
  }, [_c('img', {
    staticClass: "img-fluid rounded",
    attrs: {
      "src": _vm.kotoriImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-9"
  }, [_c('div', {
    staticClass: "row justify-content-center align-items-start"
  }, [_c('img', {
    staticClass: "kotori img-fluid rounded col-3 d-block d-sm-none d-md-none d-lg-none",
    attrs: {
      "src": _vm.kotoriImg
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "mt-5 mb-4 mb-sm-3 mt-sm-3 mb-lg-4 text-kotori col col-sm-12 text-center"
  }, [_vm._v("Shorten your URL")])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center form-pc"
  }, [_c('input', {
    ref: "urlInput",
    staticClass: "col-12 col-sm-9 url-input form-control-lg mr-md-3",
    attrs: {
      "type": "text",
      "placeholder": "https://some.url",
      "value": ""
    },
    on: {
      "click": _vm.urlInputOnClick
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "col-12 col-sm-2 btn btn-kawaii text-white"
  }, [_vm._v("pw")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fadbe0a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/404.vue
// module id = 46
// module chunks = 0